/* Holy Spirit — entradas ao rolar.
   Marca as partes de cada seção na ordem de leitura (título, texto, foto, detalhes), no máximo
   quatro passos por seção, e revela cada parte uma única vez quando ela entra na tela. */
(() => {
  const root = document.documentElement;
  if (!root.classList.contains('hs-js')) return;
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const MAX_STEPS = 4;
  const PARTS = [
    '.text-block',
    '.button',
    '.button-secondary',
    '.image-block',
    'product-card',
    '.product-card',
    '.collection-links__container > *',
    '.collection-links__images',
    '.logo-block',
    '.menu',
    '.email-signup',
  ].join(',');

  // nada dentro de partes que já se movem por conta própria, nem no topo (ele tem a própria sequência)
  const SKIP = '[id$="__hero_hs"], .sticky-add-to-cart, dialog, .drawer, header-component, #header-group, slideshow-slide';

  const fold = innerHeight * 0.92;
  // uma foto que abre começa recortada a zero, e o Chrome não a vê entrar na tela;
  // por isso ela é observada pelo elemento que a envolve
  const watched = new Map();
  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue;
        (watched.get(e.target) || e.target).classList.add('is-in');
        io.unobserve(e.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
  );
  const watch = (el) => {
    const target = el.classList.contains('hs-open') ? el.parentElement : el;
    watched.set(target, el);
    io.observe(target);
  };

  const sections = document.querySelectorAll('#MainContent .shopify-section, footer .shopify-section');
  sections.forEach((section) => {
    if (section.matches(SKIP) || section.closest(SKIP)) return;
    const parts = [...section.querySelectorAll(PARTS)].filter(
      (el) => !el.closest(SKIP) && !el.parentElement.closest(PARTS)
    );
    let step = 0;
    let lastTop = -1;
    parts.forEach((el) => {
      const box = el.getBoundingClientRect();
      if (box.height === 0) return;
      // o que já aparece na primeira tela fica como está
      if (box.top < fold) return;
      // partes lado a lado (cards de uma fileira) andam juntas no mesmo passo de ordem de leitura
      if (lastTop >= 0 && Math.abs(box.top - lastTop) > 4) step += 1;
      lastTop = box.top;
      const isWordmark = el.matches('.logo-block') && el.closest('footer') && box.width > 120;
      const isBigPicture = el.matches('.image-block') && box.width > innerWidth * 0.35;
      el.classList.add(isWordmark ? 'hs-mark' : isBigPicture ? 'hs-open' : 'hs-rise');
      const sameRow = el.matches('product-card, .product-card, .collection-links__container > *');
      const i = sameRow ? Math.min(parts.filter((p) => p.matches('product-card, .product-card, .collection-links__container > *')).indexOf(el), MAX_STEPS - 1) : Math.min(step, MAX_STEPS - 1);
      el.style.setProperty('--hs-i', Math.max(0, i) % MAX_STEPS);
      watch(el);
    });
  });

  // segurança: se algo ficar escondido por qualquer motivo, aparece depois de 4 s na tela
  setTimeout(() => {
    document.querySelectorAll('.hs-rise:not(.is-in), .hs-open:not(.is-in), .hs-mark:not(.is-in)').forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < innerHeight && r.bottom > 0) el.classList.add('is-in');
    });
  }, 4000);
})();
